import { ErrorMapping } from 'core/types/error-mapping';

export const LAYOUT_WORKFLOW_TABS = {
    CONFIG: 'config',
    DEVICE_PROPERTIES: 'edit-config',
};

export const CONFIGURATION_NAME_MAX_LENGTH = 16;

export const ERRORS_MAPPINGS: ErrorMapping[] = [{ field: 'name', errorCode: 'E_POC_ADM_DM_0097', type: 'duplicated' }];

export const SETTINGS_DEVICES_CONFIGURATION_LAYOUT_SECTIONS = {
    EVENT_HANDLING: 'ACI2_MainEventHead',
};

export const PROPERTY_STATUS = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    HIDDEN: 'HIDDEN',
} as const;
